/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'confluence-table-tree.column.contributors': 'Contributeurs',
  'confluence-table-tree.column.last-modified': 'Dernière modification',
  'confluence-table-tree.column.title': 'Nom',
  'confluence-table-tree.could-not-load': 'Chargement impossible',
  'confluence-table-tree.could-not-load-contributors': 'Impossible de charger les contributeurs',
  'confluence-table-tree.create-child-page': 'Créer une page enfant',
  'confluence-table-tree.create-page': 'Créer une page',
  'confluence-table-tree.default.page.title': 'Sans titre',
  'confluence-table-tree.default.show-all-pages-button.label': 'Afficher plus de pages',
  'confluence-table-tree.draft.lozenge': 'BROUILLON',
  'confluence-table-tree.draft.tooltip': 'Les brouillons ne peuvent être vus que par vous.',
  'confluence-table-tree.drafts-toggle.label': 'Afficher les brouillons',
  'confluence-table-tree.edit': 'Modifier',
  'confluence-table-tree.edit-in-confluence': 'Modifier dans Confluence',
  'confluence-table-tree.empty.description':
    'Créez des notes de réunion, des exigences produit, des décisions, ou tout autre contenu pour voir cet espace se remplir.',
  'confluence-table-tree.empty.title': "Il n'y a rien ici hormis du potentiel",
  'confluence-table-tree.error.description': "Impossible d'afficher ces pages. Veuillez réessayer ultérieurement.",
  'confluence-table-tree.error.row': 'Impossible de charger les pages.',
  'confluence-table-tree.error.title': "Ah, c'est bizarre…",
  'confluence-table-tree.friendly-when-created': 'Création',
  'confluence-table-tree.friendly-when-updated': 'Mise à jour',
  'confluence-table-tree.share.copied': 'Copié dans le presse-papiers',
  'confluence-table-tree.share.copy-button': 'Copier',
  'confluence-table-tree.share.subtitle': 'Partager ce lien',
  'confluence-table-tree.share.title': 'Partager la page',
  'confluence-table-tree.share.tooltip': 'Partager',
  'confluence-table-tree.view-profile': 'Afficher le profil',
};
